import i18n from "../i18n";
import {
  Accordion,
  Button,
  Text,
  Title,
  Table,
  Select,
  Group,
} from "@mantine/core";
import React, { useState, useEffect } from "react";
import moment from "moment";
import { useServerApi } from "../hooks/userServerApi";
import { openFileUrl } from "../utils/openReport";

const ReportProviderPortal = ({ name, apiEntity }) => {
  const [loading, setLoading] = useState(false);
  const [api] = useServerApi();

  const downloadReport = async () => {
    try {
      setLoading(true);
      const result = await api.Provider.getPortalReport();
      setLoading(false);

      if (result && result.data && result.data.url) {
        await openFileUrl(result.data.url);
      }
    } catch (error) {
      setLoading(false);
      console.log(error);
    }
  };

  return (
    <div>
      <Text size="xs">Download All Provider Portal Login data.</Text>

      <Button
        size="xs"
        mt="xl"
        onClick={() => downloadReport()}
        loading={loading}
      >{i18n.t("Download")}</Button>
      <></>
    </div>
  );
};

export default ReportProviderPortal;
